import { useEffect, useState } from 'react';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from '../firebase';

export function useCurrentUser() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log('[DEBUG] useCurrentUser - Iniciando listener de auth...');

    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      console.log('[DEBUG] useCurrentUser - Auth state changed:', firebaseUser?.uid || 'null');

      // Se usuário foi autenticado e há flag de login success, limpar a flag
      if (firebaseUser && localStorage.getItem('loopra_login_success')) {
        console.log('[DEBUG] Login success detected, clearing flag');
        localStorage.removeItem('loopra_login_success');
      }

      setUser(firebaseUser);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  return { user, loading };
}
